import { Route, Routes } from 'react-router-dom'
import { ReviewsAccessLayout } from 'pages/reviews/layout/ReviewsAccessLayout'
import { ReviewsPageLayout } from 'pages/reviews/layout/ReviewsPageLayout'
import { ReviewsPage } from 'pages/reviews/ui/ReviewsPage'
import { ReviewsRoutes } from './type'

export const ReviewsRouter = () => {
  return (
    <Routes>
      <Route element={<ReviewsAccessLayout />}>
        <Route element={<ReviewsPageLayout />}>
          <Route index element={<ReviewsPage />} />
          <Route path={`${ReviewsRoutes.create}`} element={<div />} />
          <Route path={`${ReviewsRoutes.view}/:id`} element={<div />} />
        </Route>
      </Route>
    </Routes>
  )
}
